/**
 * adminDebugLog — Frontend helper to fetch job debug log via Worker.
 *
 * US-19-01 Task 3: replaces direct supabase.from('pending_sync').select('prompt_input, raw_response').
 * Admin Debug Lab uses this to display prompt + raw output for any job.
 *
 * Auth: admin JWT required (Worker verifyAdmin middleware enforces).
 */

import { supabase } from '../supabase/supabaseClient';

const WORKERS_URL = import.meta.env.VITE_WORKERS_URL_COMMERCIAL
  || import.meta.env.VITE_WORKERS_URL
  || 'https://api.dichtailieu.vn';

export interface JobDebugLog {
  job_id: string;
  user_id: string;
  prompt_input: string | null;
  raw_response: string | null;
  created_at: string;
}

/**
 * Fetch debug log for a job. Returns null on 404 (not found / expired) or any error.
 * Caller (Debug Lab UI) handles null gracefully.
 */
export async function fetchAdminDebugLog(jobId: string): Promise<JobDebugLog | null> {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) return null;

  try {
    const res = await fetch(`${WORKERS_URL}/api/admin/debug-log/${encodeURIComponent(jobId)}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    return await res.json() as JobDebugLog;
  } catch {
    return null;
  }
}
